import { render, staticRenderFns } from "./EquipmentPage.vue?vue&type=template&id=8a28ba10&"
import script from "./EquipmentPage.vue?vue&type=script&lang=js&"
export * from "./EquipmentPage.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports